import request from '@/utils/request'


// 查询发现板块-评论记录列表
export function listDiscoveryComment(query) {
  return request({
    url: '/discovery/discovery/comment/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现板块-评论记录分页
export function pageDiscoveryComment(query) {
  return request({
    url: '/discovery/discovery/comment/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现板块-评论记录详细
export function getDiscoveryComment(data) {
  return request({
    url: '/discovery/discovery/comment/detail',
    method: 'get',
    params: data
  })
}

// 新增发现板块-评论记录
export function addDiscoveryComment(data) {
  return request({
    url: '/discovery/discovery/comment/add',
    method: 'post',
    data: data
  })
}

// 修改发现板块-评论记录
export function updateDiscoveryComment(data) {
  return request({
    url: '/discovery/discovery/comment/edit',
    method: 'post',
    data: data
  })
}

// 删除发现板块-评论记录
export function delDiscoveryComment(data) {
  return request({
    url: '/discovery/discovery/comment/delete',
    method: 'post',
    data: data
  })
}
